import { render, staticRenderFns } from "./KeywordsSelector.vue?vue&type=template&id=3614d1ae&"
import script from "./KeywordsSelector.vue?vue&type=script&lang=js&"
export * from "./KeywordsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports